export default __webpack_public_path__ + "static/shutterstock_6-77fb66937a89b35559e94a1877da5141.jpg";